/**
 * @module
 */
var _ = require('optimizely-client-fn');
var enums = require('core/tags').enums;
var TagError = require('core/tags').Error;

/**
 * Helper function that enforces ViewTag's value conforms to valueType and return the coerced value, if possible.
 * @param {ValueType} valueType
 * @param {*} value
 * @return {string|number} Possibly coerced value.
 * @throws {TagError} Throws an error if valueType is unknown or if value cannot be coerced to valueType.
 */
module.exports = function(valueType:ValueType, value:any): string|number {
  // TODO(ajith): Consolidate this function with core/tags/parse_value_type.
  // We allow undefined or null to signify value not available.
  if (_.isUndefined(value) || _.isNull(value)) {
    return value;
  }

  var result = value;
  switch (valueType) {
    case enums.valueType.STRING:
      if (!_.isString(value)) {
        // Coerce to string.
        result = String(value);
      }
      break;
    case enums.valueType.NUMBER:
      result = Number(value);
      if (isNaN(result)) {
        throw new TagError(value + ' is not a number');
      }
      break;
    case enums.valueType.CURRENCY:
      result = Number(value);
      if (isNaN(result) || Math.floor(result) !== result) {
        throw new TagError(value + ' cannot be parsed as currency (must be an integer)');
      }
      break;
    default:
      throw new TagError('Unknown ViewTag type: ' + valueType);
  }

  return result;
};
